export const API = {
  HOST: process.env.REACT_APP_PRIZEET_API_URL
};

export const S3_CONFIG = {
  accessId: process.env.REACT_APP_S3_BUCKET_ACCESS_ID,
  secretKey: process.env.REACT_APP_S3_BUCKET_SECRET,
  region: process.env.REACT_APP_S3_REGION,
  endpoint: process.env.REACT_APP_S3_ENDPOINT,
  bucket: process.env.REACT_APP_S3_BUCKET,
  cdn_host: process.env.REACT_APP_CDN_HOST,
  amazon_host: process.env.REACT_APP_AMAZON_HOST
};

export const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

export const SentryConfig = {
  dsn: process.env.REACT_APP_SENTRY_KEY
};
